/**
 * 공유할 스냅숏(2026-10-07) — 지도(출처별 세번)가 지금 화면의 공유 내용을 검색어 단위로 게시하고,
 * 결과 탭 바 오른쪽 위 [공유] 버튼이 구독한다. 메모리에만 둔다(카드가 살아 있을 때만 뜻이 있다).
 */
import { useEffect, useState } from "react";

export const SHARE_SNAPSHOT_EVENT = "loginhs:share-snapshot";
const norm = (q) => String(q || "").trim().replace(/\s+/g, " ");
let current = null;

export function publishShareSnapshot(q, snapshot) {
  if (!norm(q) || !snapshot) return;
  current = { q: norm(q), snapshot };
  try { window.dispatchEvent(new CustomEvent(SHARE_SNAPSHOT_EVENT, { detail: current })); } catch (_) { /* ignore */ }
}

export function clearShareSnapshot(q) {
  if (!current || current.q !== norm(q)) return;
  current = null;
  try { window.dispatchEvent(new CustomEvent(SHARE_SNAPSHOT_EVENT, { detail: null })); } catch (_) { /* ignore */ }
}

export function peekShareSnapshot(q) {
  return current && current.q === norm(q) ? current.snapshot : null;
}

/** 검색어의 지금 스냅숏. 없으면 null. */
export function useShareSnapshot(q) {
  const [snap, setSnap] = useState(() => peekShareSnapshot(q));
  useEffect(() => {
    setSnap(peekShareSnapshot(q));
    const on = () => setSnap(peekShareSnapshot(q));
    window.addEventListener(SHARE_SNAPSHOT_EVENT, on);
    return () => window.removeEventListener(SHARE_SNAPSHOT_EVENT, on);
  }, [q]);
  return snap;
}

// ── 2026-10-10: 상단 [공유] — 지금 화면에 따라 검색 결과(가장 최근에 게시된 것) 또는 고른 메모를 공유한다 ──
const pages = {};   // memo·precedent — 화면이 지금 연 것을 게시한다

/** 화면이 지금 공유할 것을 게시한다. kind = "memo" | "precedent". null 이면 지운다. */
export function publishPageShare(kind, snapshot) {
  pages[kind] = snapshot || null;
  try { window.dispatchEvent(new CustomEvent(SHARE_SNAPSHOT_EVENT, { detail: null })); } catch (_) { /* ignore */ }
}

/** mymemo 가 고른 메모({type:"memo", title, body, code, requirement, tags}). */
export function publishMemoShare(snapshot) {
  publishPageShare("memo", snapshot);
}

/** kind = "search" | "memo" | "precedent" | "hsk" — 그 화면에서 공유할 것. 없으면 null.
 *  hsk(관세율표 세번 상세)는 주소의 hsk= 를 읽는다. */
export function peekShareFor(kind) {
  if (kind === "search") return current ? current.snapshot : null;
  if (kind === "hsk") {
    const h = typeof window === "undefined" ? "" : String(new URLSearchParams(window.location.search).get("hsk") || "").replace(/\D/g, "");
    return h.length === 10 ? { code: h } : null;
  }
  return pages[kind] || null;
}

export function useShareFor(kind) {
  const [snap, setSnap] = useState(() => peekShareFor(kind));
  useEffect(() => {
    setSnap(peekShareFor(kind));
    const on = () => setSnap(peekShareFor(kind));
    window.addEventListener(SHARE_SNAPSHOT_EVENT, on);
    window.addEventListener("popstate", on);   // 관세율표에서 세번을 고르면 주소가 바뀐다
    return () => { window.removeEventListener(SHARE_SNAPSHOT_EVENT, on); window.removeEventListener("popstate", on); };
  }, [kind]);
  return snap;
}
